import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  postUrl(payload) {
    const kycId = payload?.kycId || payload?.id
    if (!kycId) {
      throw new Error('kycId is required for processing KYC')
    }

    // Utiliser le bon endpoint en fonction de l'action
    if (payload?.action === 'reject') {
      return buildApiUrl(ADMIN_ENDPOINTS.KYC_REJECT, {
        pathParams: { kycId }
      })
    } else {
      return buildApiUrl(ADMIN_ENDPOINTS.KYC_VALIDATE, {
        pathParams: { kycId }
      })
    }
  },

  format(payload = {}) {
    // Format attendu par MonRapidoo API
    const action = payload.action // 'validate', 'reject'

    if (action === 'reject') {
      return {
        adminId: 'admin_001', // À récupérer depuis la session
        reason: payload.rejectionReason || '',
        notes: payload.notes || ''
      }
    } else {
      return {
        adminId: 'admin_001', // À récupérer depuis la session
        notes: payload.notes || 'Welcome aboard !!'
      }
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to process KYC',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: raw.message || 'KYC processed successfully',
      data: raw.data || null,
    }
  },
}
